/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Space_Profile_Map_Updates_After_SaveInputs */

const en_admin_space_profile_map_updates_after_save = /** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map updates after saving the form`)
};

const de_admin_space_profile_map_updates_after_save = /** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte aktualisiert sich nach dem Speichern`)
};

const es_admin_space_profile_map_updates_after_save = /** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mapa se actualiza al guardar el formulario`)
};

const fr_admin_space_profile_map_updates_after_save = /** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La carte se met à jour après l'enregistrement du formulaire`)
};

const nl_admin_space_profile_map_updates_after_save = /** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaart wordt bijgewerkt na het opslaan van het formulier`)
};

/** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */
const it_admin_space_profile_map_updates_after_save = en_admin_space_profile_map_updates_after_save;

/** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */
const pt_br2_admin_space_profile_map_updates_after_save = en_admin_space_profile_map_updates_after_save;

/** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */
const pl_admin_space_profile_map_updates_after_save = en_admin_space_profile_map_updates_after_save;

/** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */
const hu_admin_space_profile_map_updates_after_save = en_admin_space_profile_map_updates_after_save;

/** @type {(inputs: Admin_Space_Profile_Map_Updates_After_SaveInputs) => LocalizedString} */
const ro_admin_space_profile_map_updates_after_save = en_admin_space_profile_map_updates_after_save;

/**
* | output |
* | --- |
* | "Map updates after saving the form" |
*
* @param {Admin_Space_Profile_Map_Updates_After_SaveInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_space_profile_map_updates_after_save = /** @type {((inputs?: Admin_Space_Profile_Map_Updates_After_SaveInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Space_Profile_Map_Updates_After_SaveInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "de") return de_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "es") return es_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "fr") return fr_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "nl") return nl_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "it") return it_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "pt-BR") return pt_br2_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "pl") return pl_admin_space_profile_map_updates_after_save(inputs)
	if (locale === "hu") return hu_admin_space_profile_map_updates_after_save(inputs)
	return ro_admin_space_profile_map_updates_after_save(inputs)
});
export { admin_space_profile_map_updates_after_save as "admin.space_profile_map.updates_after_save" }